<script lang="ts">
  interface Props {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | undefined
    id?: string | undefined
    centered?: boolean
    spacing?: 'none' | 'default'
    children?: import('svelte').Snippet
    sub?: import('svelte').Snippet
  }

  let {
    size = 'lg',
    tag = $bindable(undefined),
    id = undefined,
    centered = false,
    spacing = 'default',
    children,
    sub,
  }: Props = $props()

  const defaultSizeTags: { [key in typeof size]: typeof tag } = {
    xl: 'h1',
    '2xl': 'h1',
    lg: 'h2',
    md: 'h3',
    sm: 'h4',
    xs: 'h4',
  }

  // svelte-ignore state_referenced_locally
  if (!tag) tag = defaultSizeTags[size]
</script>

<div class="heading-container size-{size} spacing-{spacing}" class:centered>
  <svelte:element this={tag} class="heading" {id}>
    <span class="text">{@render children?.()}</span>
    {#if id}
      <a href="#{id}" class="anchor" aria-label="Link to this section"
        ><span class="screen-reader-text">Link to this section</span></a
      >
    {/if}
  </svelte:element>
  {#if sub}
    <p role="doc-subtitle" aria-roledescription="Subtitle">
      {@render sub?.()}
    </p>
  {/if}
</div>

<style lang="postcss">
  :where(:global(.heading-container .text :global(a))) {
    font: inherit;
  }

  .heading-container {
    --_font-heading: 'not set';
    --_pb: 'not set';

    &.spacing-default {
      padding-bottom: var(--_pb);
    }

    & > * {
      margin: 0;
    }
    & .heading {
      font: var(--_font-heading);
    }
    & [role='doc-subtitle'] {
      padding-top: 0.75rem;
      font: var(--_font-sub);
    }

    &.centered {
      text-align: center;
    }
  }
  .heading {
    position: relative;
    &:target {
      /* Maybe do something sometime here. */
    }
  }
  .anchor {
    position: absolute;
    top: 0em;
    left: -0.75em;
    opacity: 0;
    padding-right: 0.25em;
    &::before {
      content: ' # ';
    }
  }
  .heading-container:hover {
    & .anchor {
      opacity: 1;
    }
  }
  .size-2xl {
    --_pb: 4rem;
    --_font-heading: var(--display-2xl);
    --_font-sub: var(--display-2xl-sub);
  }
  .size-xl {
    --_pb: 2.75rem;
    --_font-heading: var(--display-xl);
    --_font-sub: var(--display-xl-sub);
  }
  .size-lg {
    --_pb: 1.5rem;
    --_font-heading: var(--display-lg);
    --_font-sub: var(--display-lg-sub);
  }
  .size-md {
    --_pb: 1rem;
    --_font-heading: var(--display-md);
  }
  .size-sm {
    --_pb: 1rem;
    --_font-heading: var(--display-sm);
  }
  .size-xs {
    --_pb: 1rem;
    --_font-heading: var(--display-xs);
    & .heading {
      &:target {
        & span {
          background: var(--color-bg-accent-secondary);
        }
      }
    }
  }
</style>
